



























import TwoCalender from '@/views/atoms/TwoCalender.vue'
import moment from 'moment'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import Global from '@/common/global.js'
import PopupSendMail from '@/views/template/PopupSendMail.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import PlanTable from '@/views/organisms/PlanTable.vue'
import store from '@/store'
import ApiClient from '@/common/api'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    BlueButton
    TextBox
    CheckBox
    TwoCalender
    PopupSendMail
    PopupComfirmDelete
    PlanTable
    PopupComplete
  }

  data: () ->
    month: moment().format('yyyy-MM-DD')
    nextMonth: moment().add('months', 1).format('yyyy-MM-DD')
    toyonakaEventsMonth: []
    suitaEventsMonth: []
    toyonakaFillingList: []
    suitaFillingList: []
    accept: true
    cancel: true
    supplySourceNum: store.getters.getAdminData.supply_source
    selectDay: moment().format('yyyy/MM/DD')
    level: store.getters.getAdminData.level
    start: moment().startOf('month').format('yyyy-MM-DD')
    end: moment().add('months', 1).endOf('month').format('yyyy-MM-DD')
    complete: ''
    isShowPopup: {}

  created: () ->
    @getList(@month)
    @getEvents(@start, @end)
    if @supplySourceNum == '1'
      for row, index in @toyonakaEventsMonth
        if row.start == @month && row.name == '供給不可日'
          @accept = false
    else if @supplySourceNum == '2'
      for row, index in @suitaEventsMonth
        if row.start == @month && row.name == '供給不可日'
          @accept = false

  methods: {
    clickDate: (date, bool) ->
      @selectDay = moment(date.date).format('yyyy/MM/DD')
      @getList(date.date)

      # boolは、受付可能日であればtrue。受付不可日であればfalse。
      if @supplySourceNum == '1'
        @accept = bool
      if @supplySourceNum == '2'
        @accept = bool
      if @month > date.date
        @cancel = false
      else
        @cancel = true

    goPlanSave: () ->
      @$router.push 'plan/' + moment(@selectDay).format('yyyy-MM-DD')
    switchSupplySource: (e) ->
      @supplySourceNum = e
      if e == '1'
        for row, index in @toyonakaEventsMonth
          if row.start == @month && row.name == '供給不可日'
            return @accept = false
        return @accept = true
      else if e == '2'
        for row, index in @suitaEventsMonth
          if row.start == @month && row.name == '供給不可日'
            return @accept = false
        return @accept = true
    getList: (date) ->
      api = new ApiClient()
      data = await api.get('/admin/reserve/list/' + date)
      if data
        @toyonakaFillingList = data.list[1]
        @suitaFillingList = data.list[2]
    sendMail: (id) -> 
      param =
        id: id
      api = new ApiClient()
      data = await api.post('/admin/reserve/send_mail', param)
      if data.errors.length == 0
        @complete = 'メールを送信'
        @showPopup('complete')
        @getList(moment(@selectDay).format('yyyy-MM-DD'))
        @getEvents(@start, @end)
    rowDelete: (id) ->
      param =
        id: id
      api = new ApiClient()
      data = await api.post('/admin/reserve/delete', param)
      if data.errors.length == 0
        @complete = '予約をキャンセル'
        @showPopup('complete')
        @getList(moment(@selectDay).format('yyyy-MM-DD'))
        @getEvents(@start, @end)
    monthSwitching: (v) ->
      @getEvents(v.start, v.end)
    getEvents: (start, end) ->
      @start = start
      @end = end
      param =
        start: start
        end: end
      api = new ApiClient()
      data = await api.post('/admin/event', param)
      if data
        @toyonakaEventsMonth = data.list[1]
        @suitaEventsMonth = data.list[2]
    change: (v, field) -> 
      v.field = field
      api = new ApiClient()
      data = await api.post('/admin/reserve/save', v)
      if data.errors.length == 0
        store.dispatch('setErrors', [])
      @getList(moment(@selectDay).format('yyyy-MM-DD'))
      @getEvents(@start, @end)
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    displayDay: (day) ->
      return moment(day).format('MM/DD')
  }
